module.exports = __webpack_public_path__ + "img/pullups.1a39ca99.svg";